export enum CacheRequest {
    Reload = "reload", //Reset the cached request if any
    Cache = "cache", //Return cache request if any and cache it
    Default = "no-cache" //Don't cache, Don't return any cache

}